class BrowserStorageService
{
    getLocalStorageData(name, parseValue = false)
    {
        const data = localStorage.getItem(name);
        
        return data && parseValue ? this.parseValue(data) : data;
    };

    parseValue(value) 
    {
        let parsedValue;
        if (value.toLowerCase() === "true" || value.toLowerCase() === "false") {
            parsedValue = JSON.parse(value.toLowerCase());
        } else if (/^\d+$/.test(value)) {
            parsedValue = parseInt(value);
        } else {
            parsedValue = value.toString();
        }

        return parsedValue;
    }

    setLocalStorageData(name, value)
    {
        localStorage.setItem(name, value);
    };

    getCookie(name)
    {
        const nameEQ = `${name}`;
        const ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++)
        {
            let c = ca[i];

            // If the first character is a space, remove it 
            // Continue doing this until the first character is not a space.
            while (c.charAt(0) === ' ') 
                c = c.substring(1, c.length);

            if (c.indexOf(nameEQ) === 0) 
                return c.substring(nameEQ.length, c.length);
        }

        return null;
    };

    hasCookie(name)
    {
        const cookiesOnDocument = document.cookie.split(';');

        for (let i = 0; i < cookiesOnDocument.length; i++)
        {
            let cookie = cookiesOnDocument[i];

            // If the first character is a space, remove it 
            // Continue doing this until the first character is not a space.
            while (cookie.charAt(0) === ' ') 
            cookie = cookie.substring(1, cookie.length);

            if (cookie.indexOf(name) > -1) return true;
        }

        return false;
    };

    setCookie(name, value, days, domain)
    {
        let expires = "";
        let domainVal = "";

        if (days)
        {
            const date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = `expires=${date.toUTCString()}`;
        }

        if (domain)
            domainVal = `domain=${domain}`;

        // The previous cookie is not overwritten, as it would when document.cookie would be a real string. 
        // Instead next one is added to document.cookie
        document.cookie = `${name}=${value}; ${expires}; ${domainVal}; path=/;`;
    };

    removeCookie(name, domain)
    {
        this.setCookie(name, "", -1, domain);
    };
}

export default new BrowserStorageService();